import RichTooltip from 'components/RichTooltip';
import { startCase } from 'lodash-es';
import React from 'react';
import { useSelector } from 'react-redux';
import { getShowResourceIds } from 'redux/selectors/development';
import styles from './DiagnosticResourceId.module.scss';

const stopPropagation = (e: React.SyntheticEvent | Event) => e.stopPropagation();

const DiagnosticResourceId: React.FC<{
  id: number | string | null | undefined;
  resource: string;
}> = ({ id, resource }) => {
  const showResourceIds = useSelectorLenient(getShowResourceIds);
  if (!showResourceIds || id == null) {
    return null;
  }
  return (
    <RichTooltip
      tooltip={`${startCase(resource)} ${id}`}
      childrenClassName={styles.id}
      onClick={stopPropagation}
      element="span"
    >
      {resource[0]} {id}
    </RichTooltip>
  );
};

function useSelectorLenient<TState, T>(selector: (state: TState) => T): T | null {
  try {
    // biome-ignore lint/correctness/useHookAtTopLevel: intentional try/catch to detect missing redux context
    return useSelector(selector);
  } catch (error) {
    if (error.message.includes('could not find react-redux context value')) {
      return null;
    }
    throw error; // rethrow if it's not the specific error we're looking for
  }
}

export default DiagnosticResourceId;
